import { render, staticRenderFns } from "./ProjectsTable.vue?vue&type=template&id=5454b72e&scoped=true"
import script from "./ProjectsTable.vue?vue&type=script&lang=js"
export * from "./ProjectsTable.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTable.vue?vue&type=style&index=0&id=5454b72e&prod&lang=css"
import style1 from "./ProjectsTable.vue?vue&type=style&index=1&id=5454b72e&prod&scoped=true&lang=css"
import style2 from "./ProjectsTable.vue?vue&type=style&index=2&id=5454b72e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454b72e",
  null
  
)

export default component.exports